var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WLoading',{style:({ top: 0, left: 0}),attrs:{"visible":"","opacity":1,"position":"absolute","text":_vm.$t('general.exiting')}})
}
var staticRenderFns = []

export { render, staticRenderFns }